/**
 * Main page URL
 */
export const CPRA_PAGE_URL = '/legal-portal/privacy/do-not-sell-my-personal-information';

/**
 * The cookie name which marks whether a guest opted out or not
 */
export const GUEST_CPRA_COOKIE = 'cpra_opt_out_guest';

/**
 * The cookie name which marks whether a user opted out or not
 */
export const USER_CPRA_COOKIE = 'cpra_opt_out_user';

/**
 * The cookie name which marks whether a user opted out or not
 */
export const USER_CPRA_PERMANENT_COOKIE = 'cpra_opt_out_permanent_user';

export const COOKIE_DOMAIN = '.fiverr.com';
